import adresseBo from '../Adresse'

var professionnelBo = {
    typeStructure: '',
    nom: '',
    telephone1: '',
    telephone2: '',
    mail: '',
    obs: '',
    adresse : Object.assign({},adresseBo)
};

export default professionnelBo;


// WEBPACK FOOTER //
// ./src/components/data/client/Professionnel.js